<script setup>
import PaymentMethodIcon from "./PaymentMethodIcon.vue";

const props = defineProps({
  paymentButtonsDisabled: {
    type: Boolean,
    default: false,
  },
  paymentOptionClass: {
    type: Function,
    required: true,
  },
  paymentOptions: {
    type: Array,
    required: true,
  },
  t: {
    type: Function,
    required: true,
  },
});

const emit = defineEmits(["select"]);

function isPayLink(option) {
  return Boolean(option?.details?.link);
}

function payCardBindings(option) {
  if (props.paymentButtonsDisabled || !isPayLink(option)) {
    return {};
  }

  return {
    href: option.details.link,
    target: "_blank",
    rel: "noreferrer",
  };
}
</script>

<template>
  <section class="panel">
    <div class="panel-head">
      <div>
        <h2 class="panel-title">{{ t("clickPaymentMethod") }}</h2>
        <p class="panel-subtitle">{{ t("step1") }} · {{ t("step2") }}</p>
      </div>
    </div>

    <div class="pay-grid">
      <component
        :is="isPayLink(option) ? 'a' : 'div'"
        v-for="(option, index) in paymentOptions"
        :key="`${option.option?.slug || 'opt'}-${index}`"
        class="pay-card"
        :class="[
          paymentOptionClass(option),
          { disabled: paymentButtonsDisabled },
        ]"
        v-bind="payCardBindings(option)"
        :tabindex="paymentButtonsDisabled ? -1 : 0"
        @click="!paymentButtonsDisabled && emit('select', option)"
      >
        <PaymentMethodIcon :slug="option.option.slug" />
        <span class="title">{{ option.option.title }}</span>
        <span class="arrow">
          →
        </span>
      </component>
    </div>
  </section>
</template>
